import { Snapshot } from '@ember-data/store';
import pick from 'lodash-es/pick';
import { underscore } from '@ember/string';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';
import type { ChecklistTemplateItem } from 'uplisting-frontend/models/checklist-template';

const ATTRIBUTES = ['name', 'items'];

function outgoingItems(
  items: ChecklistTemplateItem[],
): ChecklistTemplateItem[] {
  return items.map((item, position) => ({
    ...item,
    position,
  }));
}

export default class ChecklistTemplateSerializer extends ApplicationSerializer {
  serialize(snapshot: Snapshot, options: object) {
    const data = super.serialize(snapshot, options);

    if (snapshot.id) {
      const changed = Object.keys(snapshot.changedAttributes()).map((key) =>
        underscore(key),
      );

      // @ts-expect-error - we have no typings for the json api
      data.data.attributes = pick(
        // @ts-expect-error - we have no typings for the json api
        data.data.attributes,
        ATTRIBUTES.filter((key) => changed.includes(key)),
      );
      // @ts-expect-error - we have no typings for the json api
      delete data.data.relationships;
    } else {
      // @ts-expect-error - we have no typings for the json api
      data.data.attributes = pick(data.data.attributes, ATTRIBUTES);

      // @ts-expect-error - we have no typings for the json api
      data.data.relationships = {
        property: { data: { id: snapshot.belongsTo('property')?.id } },
      };
    }

    // @ts-expect-error - we have no typings for the json api
    if (data.data.attributes.items) {
      // @ts-expect-error - we have no typings for the json api
      data.data.attributes.items = outgoingItems(data.data.attributes.items);
    }

    return data;
  }
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'checklist-template': ChecklistTemplateSerializer;
  }
}
